/**
 * Store global da mensagem de retry exibida no loading.
 * Usado pela camada de retry (interceptor Axios) para sinalizar que uma
 * requisição está sendo refeita. O componente Loading lê via useRetryMessage().
 *
 * Uso no interceptor de retry:
 * - Ao iniciar uma nova tentativa: setRetryMessage(RETRY_MESSAGE)
 * - Ao finalizar (sucesso ou falha após todas as tentativas): setRetryMessage(null)
 */

export const RETRY_MESSAGE = 'A requisição falhou, estamos tentando novamente';

let message: string | null = null;
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- parameter name in callback type is for documentation
const listeners = new Set<(value: string | null) => void>();

export function setRetryMessage(value: string | null): void {
  message = value ?? null;
  listeners.forEach(listener => listener(message));
}

export function getRetryMessage(): string | null {
  return message;
}

export function subscribeRetryMessage(listener: (value: string | null) => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
